import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { AdminEmptyTab } from "@/components/dashboard/AdminEmptyTab";
import { loadPremiumCountFn } from "./-dashboard.admin.revenue.functions";

export const Route = createFileRoute("/dashboard/admin/revenue")({
  head: () => ({ meta: [{ title: "Revenue · Admin" }, { name: "robots", content: "noindex" }] }),
  component: RevenueOverview,
});

function RevenueOverview() {
  const [premium, setPremium] = useState<number | null>(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const count = await loadPremiumCountFn();
      if (!cancelled) setPremium(count ?? 0);
    })();
    return () => { cancelled = true; };
  }, []);

  const mrr = premium != null ? `$${(premium * 29).toLocaleString()}` : "—";
  const arr = premium != null ? `$${(premium * 29 * 12).toLocaleString()}` : "—";

  return (
    <AdminEmptyTab
      title="Revenue overview"
      description="Subscriptions, plans, and lifetime sales across Heallexa."
      stats={[
        { label: "Active subscriptions", value: premium ?? "—" },
        { label: "MRR (est.)", value: mrr, sub: "Premium × $29" },
        { label: "ARR (est.)", value: arr },
        { label: "Today's revenue" },
        { label: "Revenue last 7 days" },
        { label: "Revenue this month" },
        { label: "Revenue this year" },
        { label: "Churn rate" },
      ]}
      body="Detailed revenue charts and breakdowns will appear here as billing data flows in."
      primaryAction={{ label: "Export report", icon: Download }}
    />
  );
}
